import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const ModuleBasicInfoComponent = ({
    selectLMSModules, handleInnerFormChange, CourseList
}: any) => {


    return (
        <>
            <AccordionContainer
                child={

                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Course"
                            labelField="Title"
                            list={CourseList}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'CourseId'
                                );
                            }}
                            optionName='Choose course'
                            type="select"
                            value={selectLMSModules?.courseId}
                            valueField="CourseId"
                        />

                

                        <InputContainer
                            label="Title"
                            labelField="Title"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Title'
                                );
                            }}
                            type="text"
                            value={selectLMSModules?.Title}
                        />

                        <InputContainer
                            label="Short Description"
                            name="ShortDescription"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ShortDescription'
                                )
                            }}
                            type="text"
                            value={selectLMSModules?.ShortDescription}
                        />

                        <InputContainer
                            label="Duration"
                            name="Duration"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Duration'
                                )
                            }}
                            type="text"
                            value={selectLMSModules?.Duration}
                        />

                        <InputContainer
                            label="DisplayOrder"
                            name="DisplayOrder"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DisplayOrder'
                                )
                            }}
                            type="number"
                            value={selectLMSModules?.DisplayOrder}
                        />

                        <InputContainer

                            label="Mandatory"
                            name="IsMandatory"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(event, 'IsMandatory');
                            }}
                            type="checkbox"
                            value={selectLMSModules?.IsMandatory}
                        />

                        <div className='col-span-full'>
                            <InputContainer
                                label="Description"
                                name="Description"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event,
                                        'Description'
                                    )
                                }}
                                type="rte"
                                value={selectLMSModules?.Description}
                            />
                        </div>
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Module Basic Info"
            />
        </>
    )
}

export default ModuleBasicInfoComponent;  
